/* =========================================================
   solers. — shared behaviour for the landing + product page.
   Works on the static preview (forms marked data-demo) and in
   Shopify (forms post to /cart/add for real).
   ========================================================= */
(() => {
  // Every solers section includes this file, so the browser may run it several times.
  // Run once only — otherwise every listener (add to cart!) would fire once per section.
  if (window.__solersLoaded) return;
  window.__solersLoaded = true;

  const $ = (s, r = document) => r.querySelector(s);

  /* ---------- money: format cents with the shop's own Shopify money format ----------
     el carries data-money-format (e.g. "€{{amount_with_comma_separator}}"); falls back to Intl. */
  const moneyFormatter = (el) => {
    const mf = (el && el.dataset.moneyFormat) || '';
    const token = mf.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) {
      const nf = new Intl.NumberFormat((el && el.dataset.locale) || 'en', { style: 'currency', currency: (el && el.dataset.currency) || 'EUR' });
      return cents => nf.format(cents / 100);
    }
    const group = (n, decimals, thousands, decimal) => {
      const [int, frac] = (n / 100).toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const styles = {
      amount: c => group(c, 2, ',', '.'),
      amount_no_decimals: c => group(c, 0, ',', '.'),
      amount_with_comma_separator: c => group(c, 2, '.', ','),
      amount_no_decimals_with_comma_separator: c => group(c, 0, '.', ','),
      amount_with_apostrophe_separator: c => group(c, 2, "'", '.'),
      amount_no_decimals_with_space_separator: c => group(c, 0, ' ', ','),
      amount_with_space_separator: c => group(c, 2, ' ', ','),
      amount_with_period_and_space_separator: c => group(c, 2, ' ', '.'),
    };
    const style = styles[token[1]] || styles.amount;
    return cents => mf.replace(token[0], style(Math.round(cents)));
  };
  // whole-number saving in percent: (original - current) / original × 100
  const savePct = (original, current) => (original > current && original > 0 ? Math.round((original - current) / original * 100) : 0);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- toast ---------- */
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sl-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('show'), 2400);
  };

  /* ---------- modals ---------- */
  $$('[data-modal-open]').forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault(); const m = document.getElementById(btn.dataset.modalOpen); if (m) m.classList.add('open');
  }));
  $$('.sl-modal').forEach(m => m.addEventListener('click', e => {
    if (e.target === m || e.target.closest('.sl-modal__close')) m.classList.remove('open');
  }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.sl-modal.open').forEach(m => m.classList.remove('open')); });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(g => {
    const main = $('.sl-gallery__main [data-slot]', g);
    $$('.sl-thumb', g).forEach(t => t.addEventListener('click', () => {
      $$('.sl-thumb', g).forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
      if (main) main.innerHTML = t.dataset.full ? `<img src="${t.dataset.full}" alt="">` : t.innerHTML;
    }));
  });

  /* ---------- countdown (only to a real end date) ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = Date.parse(el.dataset.countdown);
    if (!end || end <= Date.now()) { el.hidden = true; return; }
    const out = $$('[data-cd]', el);
    const days = $('[data-cd-days]', el);
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { el.hidden = true; return; }
      const d = Math.floor(s / 86400); s %= 86400;
      const vals = { d, h: Math.floor(s / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      out.forEach(o => { o.textContent = pad(vals[o.dataset.cd]); });
      if (days) days.hidden = d === 0;
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- personal time-limited offer (top bar on every page) ----------
     The window starts on the visitor's first visit and survives reloads. While it is open the
     discount code is applied to the cart and prices on the page show the extra discount; when it
     closes the code is removed, prices go back and the bar never returns for this visitor —
     so the countdown always tells the truth. */
  const FLASH = (() => {
    const el = $('[data-flash-offer]');
    const api = { pct: 0, end: 0, active: () => false, onEnd: () => {} };
    if (!el || !el.dataset.code) return api;
    const KEY = 'solers_offer_v1', code = el.dataset.code, minutes = +el.dataset.minutes || 120;
    const store = {
      get() {
        try { const v = localStorage.getItem(KEY); if (v) return JSON.parse(v); } catch (_) {}
        const m = document.cookie.match(/(?:^|; )solers_offer=([^;]+)/);
        try { return m ? JSON.parse(decodeURIComponent(m[1])) : null; } catch (_) { return null; }
      },
      set(v) {
        try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (_) {}
        document.cookie = `solers_offer=${encodeURIComponent(JSON.stringify(v))}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
      },
    };
    let st = store.get();
    if (!st || st.code !== code) { st = { code, end: Date.now() + minutes * 60000 }; store.set(st); }
    const listeners = [];
    api.pct = +el.dataset.percent || 0;
    api.end = st.end;
    let expired = false;
    api.active = () => !expired && Date.now() < st.end && api.pct > 0;
    api.onEnd = (fn) => listeners.push(fn);

    const post = (body) => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const applyCode = () => {
      try { if (sessionStorage.getItem(KEY + '_applied') === code) return; } catch (_) {}
      fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' })
        .then(() => post({ discount: code }))
        .then(() => { try { sessionStorage.setItem(KEY + '_applied', code); } catch (_) {} })
        .catch(() => {});
    };
    const removeCode = () => {
      document.cookie = 'discount_code=; path=/; max-age=0';
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const codes = (cart.discount_codes || []).map(d => d.code);
        if (codes.some(c => c.toLowerCase() === code.toLowerCase())) {
          return post({ discount: codes.filter(c => c.toLowerCase() !== code.toLowerCase()).join(',') });
        }
      }).catch(() => {});
      st.removed = true; store.set(st);
    };

    if (Date.now() < st.end) {
      el.hidden = false;
      applyCode();
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.max(0, Math.floor((st.end - Date.now()) / 1000));
        const h = pad(Math.floor(left / 3600)), m = pad(Math.floor(left % 3600 / 60)), sec = pad(left % 60);
        $$('[data-fo="h"]').forEach(e => { e.textContent = h; });
        $$('[data-fo="m"]').forEach(e => { e.textContent = m; });
        $$('[data-fo="s"]').forEach(e => { e.textContent = sec; });
        $$('[data-flash-clock]').forEach(e => { e.textContent = `${h}:${m}:${sec}`; });
        if (left === 0) {
          expired = true; clearInterval(timer); el.hidden = true;
          $$('[data-flash-note]').forEach(e => { e.hidden = true; });
          removeCode(); listeners.forEach(fn => fn());
        }
      };
      const timer = setInterval(tick, 1000);
      // run the first tick after the rest of the page has wired up its listeners
      setTimeout(tick, 0);
    } else if (!st.removed) {
      removeCode();
    }
    return api;
  })();

  /* ---------- hero deal block: show the live flash price ---------- */
  $$('[data-deal]').forEach(d => {
    const fmt = moneyFormatter(d);
    const price = +d.dataset.price, compare = +d.dataset.compare || 0;
    const render = () => {
      const f = FLASH.active() ? 1 - FLASH.pct / 100 : 1;
      const now = Math.round(price * f), ref = Math.max(compare, price);
      const pct = savePct(ref, now);
      $('[data-deal-price]', d).textContent = (d.dataset.from ? 'From ' : '') + fmt(now);
      const was = $('[data-deal-was]', d); was.textContent = pct ? fmt(ref) : ''; was.hidden = !pct;
      const badge = $('[data-deal-badge]', d); badge.textContent = pct ? (d.dataset.badge || `SAVE ${pct}%`) : ''; badge.hidden = !pct;
    };
    render(); FLASH.onEnd(render);
  });

  /* ---------- hero badge: "-46% ON 2 PAIRS" from the real bundle price ----------
     original = compare-at × pairs; bundle total = price × (1 − bundle %) × pairs (and the flash offer while it runs). */
  $$('[data-sticker]').forEach(st => {
    const price = +st.dataset.price, compare = +st.dataset.compare || 0, qty = +st.dataset.qty || 2, disc = +st.dataset.discount || 0;
    const render = () => {
      const f = FLASH.active() ? 1 - FLASH.pct / 100 : 1;
      const total = Math.round(price * (1 - disc / 100) * f) * qty;
      const pct = savePct(Math.max(compare, price) * qty, total);
      const out = $('[data-sticker-pct]', st);
      if (out) out.textContent = `-${pct}%`;
      st.hidden = pct <= 0;
    };
    render(); FLASH.onEnd(render);
  });

  /* ---------- product form ---------- */
  $$('[data-product-form]').forEach(form => {
    const variants = JSON.parse($('[data-variants]', form)?.textContent || '[]');
    const fmt = moneyFormatter(form);
    const idInput = $('input[name="id"]', form);
    const qtyInput = $('input[name="quantity"]', form);
    const sizeError = $('.sl-size-error', form);
    const selected = {};            // option index -> value
    const optionCount = $$('[data-option-index]', form).reduce((n, b) => Math.max(n, +b.dataset.optionIndex + 1), 0);

    const slot = $('[data-gallery] [data-slot]');
    let shownImage = null;

    // per-pair colour & size for bundles of 2+ (discount bundles only)
    const pairsBox = $('[data-pairs]', form), pairsList = pairsBox && $('[data-pairs-list]', pairsBox);
    const pairsErr = pairsBox && $('[data-pairs-err]', pairsBox);
    const esc = (t) => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const optGroups = {};
    $$('[data-option-index]', form).forEach(b => {
      if (b.closest('.sl-offers')) return;
      const i = +b.dataset.optionIndex;
      const g = optGroups[i] || (optGroups[i] = { name: b.closest('[data-option-group]')?.dataset.optionName || `Option ${i + 1}`, values: [] });
      g.values.push({ value: b.dataset.value, label: b.dataset.label || b.dataset.value });
    });
    const choosable = Object.keys(optGroups).map(Number).filter(i => optGroups[i].values.length > 1).sort((a, b) => a - b);
    let pairs = [];
    const pairQty = () => {
      const o = $('.sl-offer.is-active', form);
      return pairsBox && o && o.dataset.optionIndex === undefined ? +o.dataset.qty : 1;
    };
    const pairsActive = () => pairQty() > 1;
    const okFor = (sel, idx, value) => variants.some(v => v.available && v.options[idx] === value &&
      v.options.every((o, i) => i === idx || sel[i] === undefined || sel[i] === o));
    const pairVariant = (sel) => variants.find(v => v.options.every((o, i) => sel[i] === o)) || null;
    function renderPairs() {
      if (!pairsBox) return;
      const q = pairQty();
      pairsBox.hidden = q < 2;
      if (q < 2) { pairsList.innerHTML = ''; return; }
      while (pairs.length < q) pairs.push({ sel: { ...selected }, touched: false });
      pairs.length = q;
      pairs.forEach(pr => { if (!pr.touched) pr.sel = { ...selected }; });
      pairsList.innerHTML = pairs.map((pr, n) => `<div class="sl-pair" data-pair="${n}" style="--cols:${choosable.length}">` +
        `<span class="sl-pair__n">Pair ${n + 1}</span>` +
        choosable.map(i => {
          const g = optGroups[i];
          const opts = g.values.map(o => {
            const ok = okFor(pr.sel, i, o.value);
            return `<option value="${esc(o.value)}"${o.value === pr.sel[i] ? ' selected' : ''}${ok ? '' : ' disabled'}>${esc(o.label)}${ok ? '' : ' (sold out)'}</option>`;
          }).join('');
          const ph = pr.sel[i] === undefined ? `<option value="" selected disabled>${esc(g.name)}</option>` : '';
          return `<label class="sl-pair__field"><span class="sl-sr">${esc(g.name)}, pair ${n + 1}</span><select data-pair-opt="${i}">${ph}${opts}</select></label>`;
        }).join('') + `</div>`).join('');
    }
    if (pairsList) pairsList.addEventListener('change', e => {
      const sel = e.target.closest('select[data-pair-opt]'); if (!sel) return;
      const pr = pairs[+sel.closest('[data-pair]').dataset.pair];
      pr.sel[+sel.dataset.pairOpt] = sel.value; pr.touched = true;
      // a colour change can make the chosen size unavailable
      const v = pairVariant(pr.sel);
      if (v && !v.available) choosable.forEach(i => { if (i !== +sel.dataset.pairOpt && !okFor(pr.sel, i, pr.sel[i])) delete pr.sel[i]; });
      if (pairsErr) pairsErr.hidden = true;
      renderPairs();
    });

    const matches = (v, except) => v.options.every((o, i) => i === except || selected[i] === undefined || selected[i] === o);

    // first visible option group the shopper still has to choose
    function missingGroup() {
      return $$('[data-option-group]', form).find(g => {
        const b = $('[data-option-index]', g);
        return b && selected[+b.dataset.optionIndex] === undefined;
      }) || null;
    }

    function currentVariant() {
      if (Object.keys(selected).length < optionCount) return null;
      return variants.find(v => matches(v)) || null;
    }

    // the best variant for the current (possibly partial) selection — drives price and image
    const bestVariant = () => currentVariant() || variants.find(v => v.available && matches(v)) || variants.find(v => matches(v));

    // Show the chosen variant's own photo as the main gallery image and mark its thumbnail.
    const fileOf = (url) => (url || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '');
    function showVariantImage(v) {
      if (!slot || !v || !v.image || v.image === shownImage) return;
      shownImage = v.image;
      slot.innerHTML = `<img src="${v.image}" alt="">`;
      const name = fileOf(v.image);
      $$('[data-gallery] .sl-thumb').forEach(t => t.classList.toggle('is-active', fileOf(t.dataset.full) === name));
    }

    function refreshAvailability() {
      // grey out sizes that are sold out for the chosen colour
      $$('[data-option-index]', form).forEach(btn => {
        const idx = +btn.dataset.optionIndex;
        const ok = variants.some(v => v.available && v.options[idx] === btn.dataset.value &&
          v.options.every((o, i) => i === idx || selected[i] === undefined || selected[i] === o));
        btn.disabled = !ok;
        if (!ok && btn.classList.contains('is-active')) { btn.classList.remove('is-active'); delete selected[idx]; }
      });
    }

    function select(btn, user = true) {
      const idx = +btn.dataset.optionIndex;
      $$(`[data-option-index="${idx}"]`, form).forEach(b => b.classList.toggle('is-active', b === btn));
      selected[idx] = btn.dataset.value;
      const label = $(`[data-option-label="${idx}"]`, form); if (label) label.textContent = btn.dataset.label || btn.dataset.value;
      if (user && sizeError) sizeError.classList.remove('show');
      refreshAvailability(); update();
      if (user) showVariantImage(bestVariant());
    }

    $$('[data-option-index]', form).forEach(btn => btn.addEventListener('click', () => select(btn)));
    $$('.sl-offer:not([data-option-index])', form).forEach(o => o.addEventListener('click', () => {
      $$('.sl-offer', form).forEach(x => x.classList.toggle('is-active', x === o)); update();
    }));

    function update() {
      const v = bestVariant() || variants[0];
      if (!v) return;
      idInput.value = currentVariant() ? v.id : '';
      const offer = $('.sl-offer.is-active', form);
      const qty = offer ? +offer.dataset.qty : 1;
      const disc = offer ? +offer.dataset.discount : 0;
      qtyInput.value = qty;
      const compare = v.compare_at_price > v.price ? v.compare_at_price : null;
      const flash = FLASH.active() ? 1 - FLASH.pct / 100 : 1;   // live personal offer, applied at checkout
      $$('[data-flash-note]', form).forEach(e => { e.hidden = flash === 1; });

      // Two different savings on a bundle card, never mixed:
      //  - tag "SAVE 15%"      = bundle discount vs the standard selling price (base × pairs)
      //  - line "You save €X"  = total saving vs the crossed-out original value (ref × pairs)
      // The tag is calculated unless the merchant typed a text of their own.
      const setSaving = (o, ref, base, each, q) => {
        const save = $('[data-offer-save]', o), tag = $('[data-offer-tag]', o);
        const pct = savePct(base * q, each * q);
        if (save) save.textContent = ref > each ? `You save ${fmt((ref - each) * q)}` : '';
        if (tag && tag.dataset.auto === undefined) tag.dataset.auto = tag.textContent.trim() === '' ? '1' : '0';
        if (tag && tag.dataset.auto === '1') { tag.textContent = pct > 0 ? `SAVE ${pct}%` : ''; tag.hidden = pct <= 0; }
      };
      $$('.sl-offer', form).forEach(o => {
        const was = $('[data-offer-was]', o);
        if (o.dataset.optionIndex !== undefined) {
          // variant bundle: the card's price is that bundle variant's own Shopify price
          const idx = +o.dataset.optionIndex;
          const bv = variants.find(x => x.options[idx] === o.dataset.value && x.available && matches(x, idx))
                  || variants.find(x => x.options[idx] === o.dataset.value && matches(x, idx));
          if (!bv) return;
          const bnow = Math.round(bv.price * flash);
          const ref = Math.max(bv.compare_at_price || 0, bv.price);
          $('[data-offer-price]', o).textContent = fmt(bnow);
          const btotal = $('[data-offer-total]', o); if (btotal) btotal.textContent = '';
          if (was) was.textContent = ref > bnow ? fmt(ref) : '';
          setSaving(o, ref, ref, bnow, 1);
          return;
        }
        const q = +o.dataset.qty, d = +o.dataset.discount;
        const each = Math.round(v.price * (1 - d / 100) * flash);
        const ref = compare || v.price;
        // "€21.21 each" + bundle total + crossed-out original value (compare-at × pairs)
        $('[data-offer-price]', o).textContent = q > 1 ? `${fmt(each)} each` : fmt(each);
        const tot = $('[data-offer-total]', o); if (tot) tot.textContent = q > 1 ? fmt(each * q) : '';
        if (was) was.textContent = ref > each ? fmt(ref * q) : '';
        setSaving(o, ref, Math.round(v.price * flash), each, q);
      });

      // unit price line: the selected variant's price, crossed-out compare-at price and SAVE %
      const unitNow = Math.round(v.price * flash), unitRef = compare || v.price, unitPct = savePct(unitRef, unitNow);
      $$('[data-unit-now]', form).forEach(e => { e.textContent = fmt(unitNow); });
      $$('[data-unit-was]', form).forEach(e => { e.textContent = unitPct > 0 ? fmt(unitRef) : ''; });
      $$('[data-unit-save]', form).forEach(e => { e.textContent = unitPct > 0 ? (e.dataset.fixedLabel || `SAVE ${unitPct}%`) : ''; e.hidden = unitPct <= 0; });

      const each = Math.round(v.price * (1 - disc / 100) * flash);
      const total = each * qty;
      const refTotal = (compare || v.price) * qty;
      $$('[data-price-now]').forEach(e => { e.textContent = fmt(total); });
      $$('[data-price-was]').forEach(e => { e.textContent = refTotal > total ? fmt(refTotal) : ''; });
      $$('[data-price-save]').forEach(e => {
        const pct = savePct(refTotal, total);
        e.textContent = pct > 0 ? (e.dataset.fixedLabel || `SAVE ${pct}%`) : ''; e.hidden = pct <= 0;
      });
      renderPairs();
      const atc = $('[data-atc-label]', form);
      if (atc) atc.textContent = v.available || pairsActive() ? `Add to cart — ${fmt(total)}` : 'Sold out';
      // sticky bar button: ask for the missing option (e.g. "Select shoe size") until the variant is complete
      const stickyBtn = document.querySelector('[data-sticky-btn]');
      if (stickyBtn) {
        const missing = pairsActive() ? null : missingGroup();
        stickyBtn.textContent = !pairsActive() && !v.available && currentVariant() ? 'Sold out'
          : missing ? `Select ${(missing.dataset.optionName || 'size').toLowerCase()}` : 'Add to cart';
        stickyBtn.classList.toggle('is-pending', !!missing);
      }
    }

    form.addEventListener('submit', e => {
      if (pairsActive()) {
        e.preventDefault();
        const chosen = pairs.map(pr => pairVariant(pr.sel));
        if (chosen.some(v => !v || !v.available)) {
          if (pairsErr) pairsErr.hidden = false;
          pairsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const counts = {};
        chosen.forEach(v => { counts[v.id] = (counts[v.id] || 0) + 1; });
        const items = Object.keys(counts).map(id => ({ id: +id, quantity: counts[id] }));
        if (form.hasAttribute('data-demo')) { toast(`Added ${chosen.length} pairs to cart ✓`); return; }
        const drawer = document.querySelector('cart-drawer');
        const useDrawer = drawer && typeof drawer.renderContents === 'function' && !$('input[name="return_to"]', form);
        const buttons = [$('[data-atc]', form), document.querySelector('[data-sticky-btn]')].filter(Boolean);
        buttons.forEach(b => { b.disabled = true; b.classList.add('is-loading'); });
        const payload = { items };
        if (useDrawer) { payload.sections = drawer.getSectionsToRender().map(sec => sec.id); payload.sections_url = window.location.pathname; }
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(r => r.json())
          .then(res => {
            if (res.status) { toast(res.description || res.message || 'Could not add to cart'); return; }
            if (!useDrawer) { window.location.href = $('input[name="return_to"]', form) ? '/checkout' : '/cart'; return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(() => toast('Could not add to cart — please try again'))
          .finally(() => buttons.forEach(b => { b.disabled = false; b.classList.remove('is-loading'); }));
        return;
      }
      if (!idInput.value) {
        e.preventDefault();
        if (sizeError) { sizeError.classList.add('show'); sizeError.closest('[data-option-group]')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      if (form.hasAttribute('data-demo')) {
        e.preventDefault();
        const c = $('[data-cart-count]'); if (c) c.textContent = +c.textContent + +qtyInput.value;
        toast(`Added ${qtyInput.value} × ${$('[data-option-label="1"]', form)?.textContent || ''} to cart ✓`);
        return;
      }
      // Shopify: add without leaving the page and slide the theme's cart drawer open.
      // Falls back to the normal form post (cart page) if the drawer isn't available.
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || $('input[name="return_to"]', form)) return;
      e.preventDefault();
      const buttons = [$('[data-atc]', form), document.querySelector('[data-sticky-btn]')].filter(Boolean);
      buttons.forEach(b => { b.disabled = true; b.classList.add('is-loading'); });
      const body = new FormData(form);
      body.append('sections', drawer.getSectionsToRender().map(sec => sec.id).join(','));
      body.append('sections_url', window.location.pathname);
      fetch(form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body })
        .then(r => r.json())
        .then(res => {
          if (res.status) { toast(res.description || res.message || 'Could not add to cart'); return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(() => form.submit())
        .finally(() => buttons.forEach(b => { b.disabled = false; b.classList.remove('is-loading'); }));
    });

    // Pre-select single-choice groups (colour, hidden one-value options like DSers "Ships From")
    // and the default bundle — but never the size, so the shopper picks it consciously.
    $$('[data-option-group]', form).forEach(group => {
      const buttons = $$('[data-option-index]', group);
      if (group.dataset.preselect === 'true' && buttons[0]) select(buttons[0], false);
      if (group.dataset.preselectIndex !== undefined && buttons.length) {
        select(buttons[Math.min(+group.dataset.preselectIndex, buttons.length - 1)] || buttons[0], false);
      }
    });
    refreshAvailability(); update();
    FLASH.onEnd(update);

    /* sticky add-to-cart bar (all screen sizes) once the main button has scrolled away */
    const sticky = $('.sl-sticky-atc'), atcBtn = $('[data-atc]', form);
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.style.paddingBottom = show ? `${sticky.offsetHeight}px` : '';
      }).observe(atcBtn);
      $('[data-sticky-btn]', sticky)?.addEventListener('click', () => {
        if (idInput.value || pairsActive()) { form.requestSubmit(); return; }
        const g = missingGroup();
        (g || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (sizeError && g && g.contains(sizeError)) sizeError.classList.add('show');
      });
    }
  });

  /* ---------- track order: open the carrier tracker in a new tab ---------- */
  $$('form[data-track-form]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const num = f.elements.tracking.value.trim().replace(/\s+/g, '');
    if (!num) return;
    window.open((f.dataset.trackUrl || 'https://t.17track.net/en#nums=') + encodeURIComponent(num), '_blank', 'noopener');
  }));

  /* ---------- cookie preferences: only shown when Shopify's cookie banner is active ---------- */
  $$('[data-cookie-prefs]').forEach(btn => {
    const api = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const reveal = () => { if (api()) btn.hidden = false; };
    reveal(); window.addEventListener('load', reveal); setTimeout(reveal, 3000);
    btn.addEventListener('click', () => { if (api()) window.privacyBanner.showPreferences(); });
  });

  /* ---------- use-cases carousel: pause the auto-scroll only while someone swipes it sideways.
     The mouse (hover, click, scrolling the page past it) never stops it. ---------- */
  $$('[data-uses]').forEach(u => {
    let t;
    const pause = () => { u.classList.add('is-paused'); clearTimeout(t); t = setTimeout(() => u.classList.remove('is-paused'), 6000); };
    ['touchstart', 'scroll'].forEach(ev => u.addEventListener(ev, pause, { passive: true }));
  });

  /* ---------- discount pop-up (sections/solers-popup.liquid) ----------
     Pick a card → email (saved as a Shopify customer subscribed to marketing) → code, applied to checkout.
     Opens only after the cookie banner has been answered; once per visitor, again after N days if closed. */
  $$('[data-solers-popup]').forEach(pop => {
    const KEY = 'solers_popup_v1', code = pop.dataset.code || '', design = pop.dataset.design === '1';
    const days = +pop.dataset.days || 7, delay = (+pop.dataset.delay || 0) * 1000;
    const hours = +pop.dataset.hours || 0;              // offer window; 0 = no timer
    const finePointer = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (_) { return {}; } };
    const save = (v) => { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), v))); } catch (_) {} };
    const steps = $$('[data-pop-step]', pop);
    const show = (name) => steps.forEach(st => { st.hidden = st.dataset.popStep !== name; });
    let lastFocus = null;

    // side tab: hidden while the pop-up is open or before the visitor has seen it
    const tab = pop.parentElement && pop.parentElement.querySelector('[data-pop-tab]');
    const tabBtn = tab && $('[data-pop-tab-btn]', tab), tabPanel = tab && $('[data-pop-tab-panel]', tab);
    const tabLabel = tab && $('[data-pop-tab-label]', tab);
    const collapseTab = () => {
      if (!tab) return;
      tabPanel.hidden = true; tabBtn.setAttribute('aria-expanded', 'false'); tab.classList.remove('is-open');
    };
    const syncTab = () => {
      if (!tab) return;
      const st = read();
      tab.hidden = !pop.hidden || !(design || st.closedAt || st.claimed) || isExpired();
      tabLabel.textContent = st.claimed ? tabLabel.dataset.claimed : tabLabel.dataset.offer;
      tab.classList.toggle('is-claimed', !!st.claimed);
      if (!st.claimed) collapseTab();
    };
    const expandTab = () => {
      if (!tab) return;
      tab.hidden = false; tabPanel.hidden = false; tabBtn.setAttribute('aria-expanded', 'true'); tab.classList.add('is-open');
    };

    // offer window: starts the first time the pop-up opens and ends for good after `hours`
    const bar = pop.parentElement && pop.parentElement.querySelector('[data-pop-bar]');
    if (bar && !design) document.body.prepend(bar);
    const offerEnds = () => { const st = read(); return hours && st.offerStart ? st.offerStart + hours * 36e5 : 0; };
    function isExpired() { return !design && hours > 0 && offerEnds() > 0 && Date.now() >= offerEnds(); }
    const left = (ms) => {
      const t = Math.max(0, Math.floor(ms / 1000));
      return [Math.floor(t / 3600), Math.floor(t % 3600 / 60), t % 60].map(n => String(n).padStart(2, '0')).join(':');
    };
    const dropCode = () => {
      document.cookie = 'discount_code=; path=/; max-age=0';
      fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(cart => {
        const codes = (cart.discount_codes || []).map(d => d.code);
        if (!codes.some(c => c.toLowerCase() === code.toLowerCase())) return;
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.filter(c => c.toLowerCase() !== code.toLowerCase()).join(',') }) });
      }).catch(() => {});
    };
    let ended = false;
    const expire = () => {
      if (ended) return;
      ended = true;
      if (bar) bar.hidden = true;
      if (tab) tab.hidden = true;
      if (!pop.hidden) close();
      if (!read().dropped) { save({ dropped: true }); dropCode(); }
    };
    const tickTimer = () => {
      if (!hours) return;
      const end = design ? Date.now() + hours * 36e5 : offerEnds();
      const timers = $$('[data-pop-timer]', pop);
      if (!end) { if (bar) bar.hidden = true; timers.forEach(e => { e.hidden = true; }); return; }
      if (isExpired()) { expire(); return; }
      const txt = left(end - Date.now());
      [...$$('[data-pop-countdown]', pop), ...(bar ? $$('[data-pop-countdown]', bar) : [])].forEach(e => { e.textContent = txt; });
      timers.forEach(e => { e.hidden = false; });
      if (bar) {
        bar.hidden = false;
        const b = $('[data-pop-bar-btn]', bar);
        if (b) b.textContent = read().claimed ? b.dataset.claimed : b.dataset.offer;
      }
    };
    if (hours) setInterval(tickTimer, 1000);

    const copyCode = (hint) => {
      const done = () => { if (hint) { const t = hint.dataset.label || hint.textContent; hint.dataset.label = t; hint.textContent = 'Copied!'; setTimeout(() => { hint.textContent = t; }, 1600); } };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    };
    const open = (step) => {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      if ((step || 'pick') === 'pick') {           // always three face-down cards again
        $$('[data-pop-card]', pop).forEach(c => c.classList.remove('is-picked'));
        pop.classList.remove('is-revealing');
      }
      show(step || 'pick');
      if (hours && !design && !read().offerStart) save({ offerStart: Date.now() });
      tickTimer();
      pop.hidden = false;
      collapseTab(); syncTab();
      document.documentElement.classList.add('sl-pop-open');
      void pop.offsetWidth;   // commit the hidden→shown change so the fade-in runs (rAF stalls in background tabs)
      pop.classList.add('is-open');
      const first = $('[data-pop-step]:not([hidden]) button, [data-pop-step]:not([hidden]) input', pop);
      if (first && finePointer) setTimeout(() => first.focus(), 60);   // iOS: a scripted focus can stop the keyboard opening
    };
    const close = () => {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('sl-pop-open');
      if (!design && !read().claimed) save({ closedAt: Date.now() });
      setTimeout(() => { pop.hidden = true; syncTab(); }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    const applyCode = () => {
      if (!code) return;
      fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
    };
    const claimed = () => { save({ claimed: true, pending: false }); applyCode(); show('done'); syncTab(); };

    $$('[data-pop-close]', pop).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !pop.hidden) close(); });

    // step 1: every card reveals the same discount
    $$('[data-pop-card]', pop).forEach(card => card.addEventListener('click', () => {
      if (pop.classList.contains('is-revealing')) return;
      pop.classList.add('is-revealing');
      card.classList.add('is-picked');
      setTimeout(() => {
        pop.classList.remove('is-revealing'); show('claim');
        const i = $('input[type=email]', pop); if (i && finePointer) i.focus();
      }, 1100);
    }));

    // step 2: Shopify customer form, posted in the background
    const form = $('[data-pop-form]', pop), err = $('[data-pop-err]', pop), btn = $('[data-pop-submit]', pop);
    const fail = (msg) => { if (err) { err.textContent = msg; err.hidden = false; } if (btn) btn.disabled = false; };
    if (form) form.addEventListener('submit', e => {
      e.preventDefault();
      // the code is only shown for a valid email — also in the theme editor
      const email = (form.querySelector('input[type=email]').value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail('Please enter a valid email address.');
      if (design) { if (err) err.hidden = true; show('done'); return; }   // editor preview: nothing is saved
      if (err) err.hidden = true;
      if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = '…'; }
      save({ pending: true });
      // Shopify answers a customer-form post in several ways (redirect with ?customer_posted=true,
      // the page itself, or a spam check). Only a real field error (e.g. an invalid address) is shown;
      // anything else that came back OK counts as subscribed. Network trouble is retried quietly and
      // reported only after 10 seconds.
      const started = Date.now();
      const done = () => { try { claimed(); } catch (_) {} if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } };
      const failLater = () => {
        const wait = Math.max(0, 10000 - (Date.now() - started));
        setTimeout(() => { if (btn) btn.textContent = btn.dataset.label; fail('Something went wrong — please try again.'); }, wait);
      };
      const post = (attempt) => fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(r => {
          if (/\/challenge/.test(r.url)) { form.submit(); return null; }   // spam check: let Shopify show it
          return r.text().then(html => ({ r, html }));
        })
        .then(res => {
          if (!res) return;
          if (/customer_posted=true/.test(res.r.url) || /data-pop-posted/.test(res.html)) return done();
          const doc = new DOMParser().parseFromString(res.html, 'text/html');
          const m = doc.querySelector('[data-pop-err]:not([hidden])');
          const text = m ? m.textContent.trim() : '';
          if (text && !/already|taken|subscribed/i.test(text)) {   // a real problem with the address
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
            return fail(text);
          }
          if (res.r.ok || text) return done();
          throw new Error('status ' + res.r.status);
        })
        .catch(() => {
          if (attempt < 2 && Date.now() - started < 8000) return new Promise(r => setTimeout(r, 2000)).then(() => post(attempt + 1));
          failLater();
        });
      post(1);
    });

    // step 3: tap to copy
    const copyBtn = $('[data-pop-copy]', pop);
    if (copyBtn) copyBtn.addEventListener('click', () => copyCode($('[data-pop-copied]', pop)));

    // side tab: reopen the offer, or expand / collapse the claimed code
    if (tab) {
      tabBtn.addEventListener('click', () => {
        if (!read().claimed) { open('pick'); return; }
        const expand = tabPanel.hidden;
        tabPanel.hidden = !expand; tabBtn.setAttribute('aria-expanded', String(expand)); tab.classList.toggle('is-open', expand);
      });
      $('[data-pop-tab-close]', tab).addEventListener('click', collapseTab);
      $('[data-pop-tab-copy]', tab).addEventListener('click', () => copyCode($('[data-pop-tab-copied]', tab)));
    }

    // countdown bar button: reopen the offer, or show the claimed code
    if (bar) bar.addEventListener('click', () => {
      if (read().claimed) expandTab(); else open('pick');
    });

    // theme editor: open while the section is selected
    if (design) {
      document.addEventListener('shopify:section:select', e => { if (e.detail && e.detail.sectionId === pop.dataset.sectionId) open('pick'); });
      document.addEventListener('shopify:section:deselect', e => { if (e.detail && e.detail.sectionId === pop.dataset.sectionId) close(); });
      syncTab(); tickTimer();
      return;
    }

    // back from Shopify's spam check with ?customer_posted=true
    const st = read();
    if (isExpired()) { expire(); return; }        // the offer is over for this visitor
    syncTab(); tickTimer();
    if (st.pending && /customer_posted=true/.test(location.search)) { open('done'); claimed(); return; }
    if (st.claimed) return;
    if (st.closedAt && Date.now() - st.closedAt < days * 864e5) return;

    // wait for the cookie banner to be answered, then the delay
    const bannerOpen = () => {
      const b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      const cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.offsetHeight > 0;
    };
    let waited = 0;
    const tick = () => {
      if (bannerOpen()) { waited += 500; setTimeout(tick, 500); return; }
      setTimeout(() => open('pick'), waited > 0 ? Math.min(delay, 2000) : delay);
    };
    setTimeout(tick, 1200);   // give the banner time to appear
  });

  /* ---------- static-preview helpers ---------- */
  $$('form[data-newsletter]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); f.reset(); toast('Thanks! You are subscribed.'); }));
  $$('[data-year]').forEach(e => { e.textContent = new Date().getFullYear(); });
})();
